import './SectionPanel.css'
import React, { PureComponent, Fragment } from 'react'
import { getThemeColor } from 'utils/utils'
import NETImage from 'components/net-image'

export default class SectionPanel extends PureComponent {
    get themeColor() {
        const { theme } = this.props
        return getThemeColor(theme).default
    }

    get titleStyle() {
        return {
            color: this.themeColor,
            borderLeftColor: this.themeColor,
        }
    }

    renderIllustration = () => {
        const {
            illustration
        } = this.props

        if (!illustration) return null

        return (
            <Fragment>
                <div className='sp-insert-title'>illustration/插图：</div>
                {
                    illustration.map((item, i) => {
                        return <div key={i} className='sp-insert-line' style={{ marginBottom: illustration.length === i + 1 ? '35px' : '0' }}>{item}</div>
                    })
                }
            </Fragment>
        )
    }

    renderItem = (item, i) => {
        const {
            presenters,
            translation
        } = this.props
        const [type, area, tag, trans] = item

        switch (type) {
            case 'p':
                // 纯文本
                return <p key={i} className='sp-item-p'>{translation ? area : tag}</p>
            case 'img':
                // 单张图片
                return (
                    <NETImage
                        usePreview
                        useAutoHeight
                        key={i}
                        className='sp-item-img'
                        prefix={this.props.theme}
                        src={area}
                        styles={tag}
                    />
                )
            case 'i':
                // 图片的文字说明
                return <div key={i} className='sp-item-i' style={tag}>{area}</div>
            case 'pn':
                // 带主讲人的纯文本
                // console.log('-----', presenters, tag)
                const presenter = presenters[tag]
                return (
                    <p key={i} className='sp-item-p'>
                        <span className='sp-item-name' style={{ color: presenter.color }}>
                            {translation ? presenter.nick : presenter.cn}
                        </span>{translation ? area : trans}
                    </p>
                )
            case 'pm':
                // 诗歌
                return <div key={i} className='sp-item-pm'>{area}</div>
            case 'br':
                // 换行
                return <br key={i} />
            default:
                return null
        }
    }

    renderSection = (item, i) => {
        const {
            sections,
            sectionId,
            handleSectionChange,
        } = this.props
        const {
            id,
            title,
            content,
            duration
        } = item

        return (
            <div id={`section-${id}`} key={id} className='sp-item' style={{ marginBottom: sections.length === i + 1 ? '.2rem' : '0' }} >
                <div
                    onClick={() => handleSectionChange(id, duration)}
                    className={`sp-item-title ${sectionId === id ? 'sp-title-on' : 'sp-title-off'}`}
                    style={sectionId === id ? this.titleStyle : {}}
                >
                    {title}
                </div>
                {
                    content.map(this.renderItem)
                }
            </div>
        )
    }

    render() {
        const {
            sections,
        } = this.props

        return (
            <div id='sections' className='panel-container'>
                {
                    sections.map(this.renderSection)
                }
                {
                    this.renderIllustration()
                }
            </div>
        )
    }
}